import { api } from 'webReservations/api';

export const sendEmailVerification = async (email: string): Promise<void> =>
  api.post('/verify-email', { email });
